export default __webpack_public_path__ + "static/subset-Aeroport-5ff15b6f913a4d85edd8845ee135388c.woff";